export default function sortByProperty(object, key) {
  if (!object) return;

  return object.sort((firstElement, secondElement) => {
    if (firstElement[key] === secondElement[key]) {
      return 0;
    }

    return firstElement[key] < secondElement[key] ? -1 : 1;
  });
}
